import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-conditions-dialog',
  templateUrl: './terms-conditions-dialog.component.html',
  styleUrls: ['./terms-conditions-dialog.component.scss']
})
export class TermsConditionsDialogComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<TermsConditionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {pdfSrc:string},
  ) { 
  }


  ngOnInit(): void {
  }

}
